<script lang="ts">
import {Vue, Component} from 'vue-facing-decorator';
import NavBar from "@/component/common/NavBar.vue";
import ReferendumComponent from "@/component/project/ReferendumComponent.vue";


@Component({
  components: {ReferendumComponent, NavBar}
})
export default class ReferendumView extends Vue {

}
</script>

<template>
  <NavBar/>
  <div class="view-container">
    <ReferendumComponent/>
  </div>
</template>

<style scoped>
.view-container {
  min-height: 100vh;
  padding: 3rem 2rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

@media (max-width: 768px) {
  .view-container {
    padding: 1rem;
  }
}
</style>
